import Vue from 'vue'
import state from './state'
import VueResource from 'vue-resource'
import settings from '@/settings'
import services from '@/services'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  INIT_APP: ({ commit, dispatch }, to) => {
    return new Promise((resolve, reject) => {
      if (to.name === 'DirectLogin') {
        localStorage.setItem(state.storage, to.query.key)
        localStorage.setItem(state.refreshStorage, to.query.refresh_key)
      }

      services.fromStorageToStore()
      services.initInterceptors()

      let token = state.token
      if (token !== null) {
        dispatch('GET_USER_DATA').then(res => {
          dispatch('BEFORE_INIT')
          dispatch('GET_PERMISSIONS').then(res => {
            dispatch('GET_METADATA').then(res => {
              dispatch('GET_APP_VERSION')
              resolve()
            }, err => {
              dispatch('BEFORE_INIT')
              reject(err)
            })
          }, err => {
            dispatch('BEFORE_INIT')
            reject(err)
          })
        }, err => {
          dispatch('BEFORE_INIT')
          if (to.name === 'DirectLogin') window.location.href = window.location.origin + '/login'
          reject(err)
        })
      } else {
        dispatch('BEFORE_INIT')
        resolve()
      }
    })
  },
  LOGIN: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/login`, user).then(res => {
        localStorage.setItem(state.storage, res.body.access_key)
        localStorage.setItem(state.refreshStorage, res.body.refresh_key)
        commit('SET_AUTH', { token: res.body.access_key, refreshToken: res.body.refresh_key })
        commit('SET_USER', res.body.user_model)
        commit('SET_ROLE', res.body.user_model.role)
        commit('UPDATE_TOTALS_FROM_USER', res.body.user_model)
        dispatch('GET_PERMISSIONS').then(res => {
          dispatch('GET_METADATA').then(res => {
            dispatch('GET_APP_VERSION')
            resolve()
          }, err => {
            reject(err)
          })
        }, err => {
          reject(err)
        })
        if (res.body.user_model.role === 'admin') dispatch('GET_COUNTS')
      }, err => {
        reject(err)
      })
    })
  },
  REFRESH_TOKEN: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit('CLEAR_TOKEN')
      Vue.http.get(`${apiUrl}${version}/users/refresh`, { headers: {'Authorization': `Bearer ${state.refreshToken}`} }).then(res => {
        localStorage.setItem(state.storage, res.body.access_key)
        localStorage.setItem(state.refreshStorage, res.body.refresh_key)
        commit('SET_AUTH', { token: res.body.access_key, refreshToken: res.body.refresh_key })
        resolve()
      }, err => {
        reject(err)
      })
    })
  },
  LOGOUT: ({ commit, dispatch }, quite) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/users/logout`).then(res => {
        services.clearAllAuthData()
        if (!quite) {
          location.reload()
        }
        resolve()
      }, err => {
        services.clearAllAuthData()
        if (!quite) {
          location.reload()
        }
        reject(err)
      })
    })
  },
  BEFORE_INIT: ({ commit, dispatch }) => {
    commit('SET_INIT', true)
    commit('SET_LOADER', false)
  },
  REGISTER_EMAIL: ({ commit, dispatch }, credentials) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/register/email`, credentials).then(res => {
        localStorage.setItem(state.registrationStorage, res.body.registration_access_key)
        localStorage.setItem(state.registrationStorageStep, 2)

        commit('SET_REGISTRATION_STEP', 2)
        commit('SET_REGISTRATION_TOKEN', res.body.registration_access_key)
        resolve()
      }, err => {
        reject(err)
      })
    })
  },
  REGISTER_PHONE: ({ commit, dispatch }, credentials) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/register/phone`, credentials).then(res => {
        localStorage.setItem(state.registrationStorageStep, 3)
        commit('SET_REGISTRATION_STEP', 3)
        resolve()
      }, err => {
        reject(err)
      })
    })
  },
  SEND_CODE_AGAIN: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/users/register/phone-again`).then(res => {
        resolve()
      }, err => {
        reject(err)
      })
    })
  },
  REGISTER_CODE: ({ commit, dispatch }, secureCode) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/register/code`, { security_code: secureCode }).then(res => {
        localStorage.removeItem(state.registrationStorage)
        localStorage.removeItem(state.registrationStorageStep)

        commit('SET_REGISTRATION_STEP', 1)
        commit('SET_REGISTRATION_TOKEN', null)
        resolve()
      }, err => {
        reject(err)
      })
    })
  },
  CONFIRM_EMAIL: ({ commit, dispatch }, token) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/users/register/confirm`, { headers: {'Authorization': `Bearer ${token}`} }).then(res => {
        resolve()
      }, err => {
        reject(err)
      })
    })
  },
  RESET_PASSWORD: ({ commit, dispatch }, email) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/recover`, { email: email }).then(res => {
        resolve()
      }, err => {
        reject(err)
      })
    })
  },
  CONFIRM_RESET_PASSWORD: ({ commit, dispatch }, {token, password}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(
        `${apiUrl}${version}/users/reset`,
        { password: password },
        { headers: {'Authorization': `Bearer ${token}`} })
        .then(res => {
          resolve()
        }, err => {
          reject(err)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/auth/actions.js